<template>
    <div v-if="agencyListInfo">
        <Loading :isShow="isShowLoading"></Loading>
        <div v-if="!isShowLoading">
            <div class="toast" v-if="showToast">
                <van-overlay :show="showOverlay">
                    <div class="wrap_main" @click.stop>
                        <div class="title">将有专业贷款机构为您服务</div>
                        <div class="title_desc">请注意接听电话 98%的用户通过咨询成功</div>
                        <div>
                            <ul>
                                <li v-for="(item,index) in agencyListInfo" :key="index" class="item">
                                    <div style="display: flex;">
                                        <img :src="item.icon" alt="">
                                        <div style="display: flex;justify-content: space-between;width: 100%;">
                                            <div>
                                                <div class="name">{{item.name}}</div>
                                                <div class="desc">最快{{item.serviceDays}}天放贷 | 咨询人数:&nbsp; {{item.zixunNums}}</div>
                                            </div>
                                            <div class="money">{{item.limitEnd | filter_loan_money}}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!--<div>我已阅读并同意《个人信息授权书》</div>-->
                        <!--<div class="agree">
                            <div v-if="xy_selected" class="xy_selected" @click="xy_selected=false"></div>
                            <div v-else class="xy_selected" style="background: url('../assets/img/vip/agency_xy_no_choice.png')no-repeat center !important;background-size:cover !important;border: 1px solid #ddd !important;" @click="xy_selected=true"></div>
                            我已阅读并同意
                                <span style="color: #3B72FF;" @click.stop="link1">《个人信息授权书》</span>
                        </div>-->
                        <!--<div class="qrzx" @click="qrzxMethod">咨询下载</div>-->
                        <div class="agree">申请即代表阅读并同意
                            <span style="color: #3B72FF;" @click.stop="link1">《个人信息授权书》</span></div>
                        <div class="qrzx" @click="xgfaMethod">继续申请</div>
                    </div>
                </van-overlay>
            </div>
        </div>

    </div>
</template>

<script>
    import Loading from '@/components/loading';
    export default {
        name: "agencyToast",
        props:{
            agencyListInfo:{
                type:Array
            },isShowLoading:{
                type:Boolean
            }
        },
        components:{
          Loading
        },
        data(){
            return{
                showOverlay:true,
                showToast:true,
                xy_selected:false
            }
        },filters:{
            filter_loan_money(value){
                var num = Number(value);
                if(num < 10000){
                    return num;
                }
                return (num/10000).toFixed(0)+"万";
            }
        },methods:{
            qrzxMethod(){
                if(!this.xy_selected){
                    this.util.toast({ msg: "请先勾选协议" });
                    return;
                }
                let agencyIds="";
                this.agencyListInfo.forEach(e=>{
                   agencyIds+=e.id+","
                })
                this.$get('/app/api/v1/order/zyb/editAgency',{agencyIds:agencyIds})
                    .then(res => {
                        if (res.code == 200) {
                            this.$emit('xgfaMethod');
                        }
                    })
                    .catch(error => { });
            },
            xgfaMethod(){
                this.$emit('xgfaMethod');
            },
            link1(){
                window.location.href = "https://thread.tcjhz.com/agreement/shouquan.html";
            },
        }
    }
</script>

<style scoped>
    *{
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .wrap_main{
        width: 100%;
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.2rem 0.2rem 0 0;
        padding: 0 0.2rem;
    }

    .wrap_main .title{
        height: 0.18rem;
        font-size: 0.2rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.18rem;
        text-align: center;
        margin-top: 0.25rem;
    }

    .wrap_main .title_desc{
        height: 0.16rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #FF514A;
        line-height: 0.16rem;
        text-align: center;
        margin: 0.08rem 0 0.2rem 0;
    }

    .wrap_main .item{
        background: rgba(0, 134, 255, 0.05);
        border-radius: 0.09rem;
        border: 1px solid #B0C6FF;
        margin-bottom: 0.1rem;
        border: none;
    }
    .item img{
        width: 0.3rem;
        border-radius: 3px;
        margin: auto 0.15rem;
    }

    .item .name{
        height: 0.16rem;
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.16rem;
        margin-top: 0.12rem;
    }

    .item .desc{
        height: 0.14rem;
        font-size: 0.1rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.14rem;
        margin-top: 0.06rem;
        margin-bottom: 0.12rem;
    }

    .item .money{
        margin: auto 0.3rem;
        font-size: 0.16rem;
        font-weight: 500;
        color: #FF7500;
    }

    .wrap_main .agree{
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0.11rem 0 0.05rem 0.12rem;
    }

    .wrap_main .agree .xy_selected{
        width: 0.15rem;
        height: 0.15rem;
        display: inline-block;
        background: url('../assets/img/vip/agency_xy_choice.png')no-repeat center;
        background-size:cover;
        vertical-align:middle;
    }
    .wrap_main .qrzx{
        height: 0.45rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        line-height: 0.45rem;
        text-align: center;
        font-size: 0.16rem;
        font-weight: 500;
        color: #FFFFFF;
        margin: 0 0 0.3rem 0;
    }

    .wrap_main .xgfa{
        width: 1rem;
        height: 0.25rem;
        font-size: 0.16rem;
        font-weight: 400;
        color: #000000;
        line-height: 0.25rem;
        margin: 0.1rem auto;
        text-align: center;
    }
</style>
